
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("6vx1i", function(module, exports) {
/* ReadingAidsAcronymsHighlighter.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $3IBnw = parcelRequire("3IBnw");


var $aJv6Q = parcelRequire("aJv6Q");


var $jmjWc = parcelRequire("jmjWc");


var $bjVRl = parcelRequire("bjVRl");

const $7618df873c80ee96$var$readingAidsPopupPortalContainerId = 'reading-aids-portal-container';

const $7618df873c80ee96$var$ReadingAidsSpotlightWrapper = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "7h_DJ",
    name: "ReadingAidsSpotlightWrapper",
    loader: async ()=>(await (parcelRequire("lhrLa"))).ReadingAidsSpotlightWrapper
});

const $7618df873c80ee96$var$ReadingAidsPopup = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "fofjy",
    name: "ReadingAidsPopup",
    loader: async ()=>(await (parcelRequire("hyEPY"))).ReadingAidsPopup
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $7618df873c80ee96$var$Container = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1reoewfl _18m9ewfl _kqswh2mm _1pby1o8a",
            __cmplp.className
        ])
    });
});
const $7618df873c80ee96$var$ReadingAidsAcronymsHighlighterComponent = ({ contentId: contentId })=>{
    const { showPopup: showPopup, autohighlightContext: autohighlightContext, autohighlightSelectionRect: autohighlightSelectionRect, autohighlightText: autohighlightText, sessionId: sessionId, showSpotlight: showSpotlight } = (0, $bjVRl.useReadingAidsState)();
    const portalContainerRef = (0, $42omo.useRef)(null);
    const { hideAutohighlightPopup: hideAutohighlightPopup, setPortalContainerRef: setPortalContainerRef } = (0, $bjVRl.useReadingAidsActions)();
    const selectionRect = {
        top: autohighlightSelectionRect.top,
        left: autohighlightSelectionRect.left,
        width: autohighlightSelectionRect.width,
        height: autohighlightSelectionRect.height
    };
    (0, $42omo.useEffect)(()=>{
        setPortalContainerRef({
            portalContainerRef: portalContainerRef
        });
    }, [
        portalContainerRef,
        setPortalContainerRef
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($7618df873c80ee96$var$Container, {
        id: $7618df873c80ee96$var$readingAidsPopupPortalContainerId,
        ref: portalContainerRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($7618df873c80ee96$var$ReadingAidsSpotlightWrapper, {
        contentId: contentId,
        selectionRect: selectionRect,
        showSpotlight: showSpotlight
    }), showPopup && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($7618df873c80ee96$var$ReadingAidsPopup, {
        selectedText: autohighlightText,
        additionalContext: autohighlightContext,
        selectionRect: selectionRect,
        isReadingAidsOpen: showPopup,
        onResult: ()=>{},
        onClose: hideAutohighlightPopup,
        contentId: contentId,
        popupPortalContainerId: $7618df873c80ee96$var$readingAidsPopupPortalContainerId,
        isAutohighlighted: true,
        sessionId: sessionId
    }));
};
const $7618df873c80ee96$export$ffdc57aecb97ae41 = (0, $aJv6Q.withErrorBoundary)({
    attribution: (0, $3IBnw.Attribution).KNOWLEDGE_DISCOVERY
})($7618df873c80ee96$var$ReadingAidsAcronymsHighlighterComponent);
module.exports["ReadingAidsAcronymsHighlighter"] = $7618df873c80ee96$export$ffdc57aecb97ae41;

});

parcelRegister("bjVRl", function(module, exports) {

var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");

const $d2a35dc366472da4$var$initialState = {
    portalContainerRef: null,
    autohighlightText: '',
    autohighlightContext: '',
    sessionId: '',
    autohighlightSelectionRect: {
        top: 0,
        left: 0,
        width: 0,
        height: 0
    },
    autohighlightHovered: false,
    showPopup: false,
    popupLoading: false,
    showSpotlight: false,
    existingMap: new Map(),
    lastAcronymReset: ()=>{},
    defineDefinitionOpen: false
};
const $d2a35dc366472da4$export$e324594224ef24da = {
    showAutohighlightPopup: ({ autohighlightText: autohighlightText, autohighlightContext: autohighlightContext, autohighlightSelectionRect: autohighlightSelectionRect, lastAcronymReset: lastAcronymReset, sessionId: sessionId })=>({ setState: setState })=>{
            setState({
                autohighlightText: autohighlightText,
                autohighlightContext: autohighlightContext,
                autohighlightSelectionRect: autohighlightSelectionRect,
                lastAcronymReset: lastAcronymReset,
                sessionId: sessionId,
                showPopup: true,
                popupLoading: true
            });
        },
    hideAutohighlightPopup: ()=>({ setState: setState, getState: getState })=>{
            getState().lastAcronymReset();
            setState({
                ...getState(),
                showPopup: false,
                popupLoading: false
            });
        },
    setDefineDefinitionOpen: ({ defineDefinitionOpen: defineDefinitionOpen })=>({ setState: setState, getState: getState })=>{
            setState({
                ...getState(),
                defineDefinitionOpen: defineDefinitionOpen
            });
        },
    setAutohighlightPopupLoaded: ()=>({ setState: setState, getState: getState })=>{
            getState().lastAcronymReset();
            setState({
                ...getState(),
                popupLoading: false
            });
        },
    setAutohighlightHovered: ({ autohighlightHovered: autohighlightHovered })=>({ setState: setState, getState: getState })=>{
            setState({
                ...getState(),
                autohighlightHovered: autohighlightHovered
            });
        },
    showAutohighlightSpotlight: ({ autohighlightSelectionRect: autohighlightSelectionRect })=>({ setState: setState, getState: getState })=>{
            setState({
                ...getState(),
                showSpotlight: true,
                autohighlightSelectionRect: autohighlightSelectionRect
            });
        },
    setPortalContainerRef: ({ portalContainerRef: portalContainerRef })=>({ setState: setState, getState: getState })=>{
            setState({
                ...getState(),
                portalContainerRef: portalContainerRef
            });
        }
};
const $d2a35dc366472da4$export$f24428a461500521 = (0, $1P1Tu.createStore)({
    initialState: $d2a35dc366472da4$var$initialState,
    actions: $d2a35dc366472da4$export$e324594224ef24da,
    name: 'readingAidsStore'
});
const $d2a35dc366472da4$export$c6f45fcecbb3630d = (0, $9zUhf.createActionsHook)($d2a35dc366472da4$export$f24428a461500521);
const $d2a35dc366472da4$export$94639db5354ca53c = (0, $9zUhf.createStateHook)($d2a35dc366472da4$export$f24428a461500521);
module.exports["useReadingAidsActions"] = $d2a35dc366472da4$export$c6f45fcecbb3630d;
module.exports["useReadingAidsState"] = $d2a35dc366472da4$export$94639db5354ca53c;

});

parcelRegister("lhrLa", function(module, exports) {

let $f7e0b7fe1134fa59$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $f7e0b7fe1134fa59$var$load("fdsim").then(()=>parcelRequire('jgOPc'));

});

parcelRegister("hyEPY", function(module, exports) {

let $cc854a169e0b528d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $cc854a169e0b528d$var$load("h3ABO"),
    $cc854a169e0b528d$var$load("1OKix"),
    $cc854a169e0b528d$var$load("e9sw5"),
    $cc854a169e0b528d$var$load("3ykLj"),
    $cc854a169e0b528d$var$load("lTK3c"),
    $cc854a169e0b528d$var$load("1WXdc"),
    $cc854a169e0b528d$var$load("5o4Kn"),
    $cc854a169e0b528d$var$load("6rS39"),
    $cc854a169e0b528d$var$load("3l0el"),
    $cc854a169e0b528d$var$load("2YffH"),
    $cc854a169e0b528d$var$load("awWN9"),
    $cc854a169e0b528d$var$load("ly1nW"),
    $cc854a169e0b528d$var$load("bdVyf"),
    $cc854a169e0b528d$var$load("eZhut"),
    $cc854a169e0b528d$var$load("4YJm9"),
    $cc854a169e0b528d$var$load("50ame"),
    $cc854a169e0b528d$var$load("9TQyl"),
    $cc854a169e0b528d$var$load("bo7iw"),
    $cc854a169e0b528d$var$load("hyzoX"),
    $cc854a169e0b528d$var$load("jEvZI"),
    $cc854a169e0b528d$var$load("c7Kmx"),
    $cc854a169e0b528d$var$load("eBRUf"),
    $cc854a169e0b528d$var$load("im1VN"),
    $cc854a169e0b528d$var$load("9anPW"),
    $cc854a169e0b528d$var$load("fjVVr"),
    $cc854a169e0b528d$var$load("rFdxz"),
    $cc854a169e0b528d$var$load("aapZc"),
    $cc854a169e0b528d$var$load("fyc8C"),
    $cc854a169e0b528d$var$load("2tIxk"),
    $cc854a169e0b528d$var$load("dLq4a"),
    $cc854a169e0b528d$var$load("3yXM9"),
    $cc854a169e0b528d$var$load("6wr18"),
    $cc854a169e0b528d$var$load("h9S8v"),
    $cc854a169e0b528d$var$load("3q2Ng"),
    $cc854a169e0b528d$var$load("jRpDi"),
    $cc854a169e0b528d$var$load("Wowvf"),
    $cc854a169e0b528d$var$load("iXxzp"),
    $cc854a169e0b528d$var$load("jUBhK"),
    $cc854a169e0b528d$var$load("ddJJa"),
    $cc854a169e0b528d$var$load("27glK"),
    $cc854a169e0b528d$var$load("bvY53"),
    $cc854a169e0b528d$var$load("f6ci5"),
    $cc854a169e0b528d$var$load("3GuOt"),
    $cc854a169e0b528d$var$load("5bjXP"),
    $cc854a169e0b528d$var$load("k3jER"),
    $cc854a169e0b528d$var$load("9ldRJ"),
    $cc854a169e0b528d$var$load("9wzNh"),
    $cc854a169e0b528d$var$load("3Mspc"),
    $cc854a169e0b528d$var$load("37ldp"),
    $cc854a169e0b528d$var$load("hhss7"),
    $cc854a169e0b528d$var$load("6iz6l"),
    $cc854a169e0b528d$var$load("4SCW2"),
    $cc854a169e0b528d$var$load("ffEVr"),
    $cc854a169e0b528d$var$load("219St"),
    $cc854a169e0b528d$var$load("b1DMS"),
    $cc854a169e0b528d$var$load("lVrrs"),
    $cc854a169e0b528d$var$load("3NkiL"),
    $cc854a169e0b528d$var$load("82uul"),
    $cc854a169e0b528d$var$load("eTYdV"),
    $cc854a169e0b528d$var$load("hCiBy"),
    $cc854a169e0b528d$var$load("7EorR"),
    $cc854a169e0b528d$var$load("avRkh")
]).then(()=>parcelRequire('cmXz4'));

});


//# sourceMappingURL=ReadingAidsAcronymsHighlighter.8f462ad2.js.map
